// Components
import { LabeledFormInput } from "../LabeledFormInput";

// Interfaces
import SimpleTextField from "../../InputComponents/SimpleTextField";

type TZipCodeInputProps = {
	zipCode: string | undefined;
	setZipCode: (zip: string) => void;
	required?: boolean;
	disabled: boolean;
	loading: boolean;
};

function ZipCodeInput(props: Readonly<TZipCodeInputProps>) {
	const { zipCode, setZipCode, required = false, disabled, loading } = props;

	function hasErrors() {
		return required && !zipCode;
	}

	return (
		<LabeledFormInput
			label="ZIP Code"
			formInput={
				<SimpleTextField
					sx={{}}
					editable
					outlined
					text={zipCode}
					placeholder={"Enter ZIP Code"}
					error={hasErrors()}
					classes={hasErrors() ? "!shadow-thin-red-line !bg-light-error" : ""}
					onActionUpdate={(value) => {
						setZipCode(value);
					}}
					disabled={disabled || loading}
					inputProps={{
						placeholder: "ZIP Code",
					}}
				/>
			}
		/>
	);
}

export default ZipCodeInput;
